import * as React from 'react'

import { Logger, StringMap, GetProfilesOutput, Profile } from '@utils'
import { AllDownloadsPayload, DownloadStatusPayload } from '@shared/SPA/UWPNotifier'
import { Subtract } from '../../widgets/DVWebNodeDetail/utils/utils'
import { MetaData, OfflineMetaData, OfflineSavedImages } from '../../widgets/DVWebNodeSPA/utils/offlineStorageTypes'

const { Provider, Consumer } = React.createContext({})

type GetDownloadType = { download: DownloadStatusPayload, showModalBeforePlay: boolean }
export type SaveMetaData = (titleId: string) => Promise<void>
export type GetMetaData = () => Promise<MetaData[]>
export type HasDownloadCompleted = (titleId: string) => boolean
export type GetDownload = (titleId: string) => GetDownloadType

export interface SPAProfiles extends GetProfilesOutput {
  currentProfile: Profile
}

export type SpaContextProps = {
  saveOfflineData: SaveMetaData
  getMetaData: GetMetaData
  strings: StringMap
  downloads: AllDownloadsPayload
  metaData: OfflineMetaData
  savedImages: OfflineSavedImages
  getDownload: GetDownload
  hasDownloadCompleted: HasDownloadCompleted
  logger: Logger
  profiles?: SPAProfiles
}

export const withSpaContext = <P extends SpaContextProps>(Component: React.ComponentType<P>) => {
  return (props: Subtract<P, SpaContextProps>) => (
    <Consumer>{spaContext => <Component {...(spaContext as SpaContextProps)} {...(props as P)} />}</Consumer>
  )
}

export type MaybeSpaContextProps = {
  saveOfflineData?: SaveMetaData
  getMetaData?: GetMetaData
  strings?: StringMap
  downloads?: AllDownloadsPayload
  metaData?: MetaData[]
  getDownload?: GetDownload
  hasDownloadCompleted?: HasDownloadCompleted
  logger?: Logger
}

export const withMaybeSpaContext = <P extends MaybeSpaContextProps>(Component: React.ComponentType<P>) => {
  return (props: Subtract<P, MaybeSpaContextProps>) => (
    global.__NATIVEAPP__ ? (
      <Consumer>{spaContext => <Component {...(spaContext as MaybeSpaContextProps)} {...(props as P)} />}</Consumer>
    ) : (
      <Component {...(props as P)} />
    )
  )
}

export { Consumer as SpaConsumer, Provider }
